module.exports = __webpack_public_path__ + "static/media/31.faa19f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/31.png
// module id = 399
// module chunks = 0